import * as constants from "./../constants";
import { logoutEvent, trackEvent } from '../../analytics';
import * as logger from './../../logger';
import { getVehicleNumberValues, getAvatarStringFromName, getVehicleNumberValuesDWeb } from "./utils/utils"
import moment from "moment";

export const getFilteredConfig = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: 'POST',
    url: "/configs/filtered",
    data,
    success: (response) => processFilteredConfig(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError
  }
})

const processFilteredConfig = (response) => {
  return { type: constants.GET_FILTERED_CONFIG, payload: response.response ? response.response : {} }
}

export const getFavFuelLocations = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/fuel_prices/favourite",
    data: null,
    success: (response) => { return { type: constants.SET_USER_FAV_FUEL_LOCATIONS, payload: response.response ? response.response : [] } },
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
export const getAllFuelLocations = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/fuel_prices/all",
    data: null,
    success: (response) => { return { type: constants.SET_USER_ALL_FUEL_LOCATIONS, payload: response.response ? response.response : [] } },
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
export const getFuelHistoryLocation = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/fuel_prices/location/history/" + data.locId,
    data: null,
    success: (response) => { return { type: constants.SET_USER_SINGLE_FUEL_LOCATION, payload: response.response ? response.response : [] } },
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
export const updateChatView = (value) => {
  return { type: constants.UPDATE_CHAT_VIEW, payload: value }
}
export const setFavLoc = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/fuel_prices/location/favourite",
    data: data,
    success: (response) => { return { type: null, payload: null } },
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});

export const GetValuesFromGst = (gstNumber, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/elr/gst_info/" + gstNumber,
    success: (response) => { return { type: constants.GET_DETAILS_FROM_GST, payload: response.response ? response.response : [] } },
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});

export const toggleChatSupport = (value) => {
  return { type: constants.TOGGLE_CHAT_SUPPORT, payload: value }
}

export const getMultiUserList = (onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/org/users",
    success: (response) => handleMultiUserList(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});

const handleMultiUserList = (response) => {
  let payloadData = response.response;
  return { type: constants.GET_MULTI_USER_LIST, payload: payloadData }
}

export const addUserMultiUser = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/multi-user/add",
    data,
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});

export const editUserMultiUser = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "PUT",
    url: "/multi-user/edit",
    data,
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});

export const editUserStatus = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "PUT",
    url: "/org/user/status",
    data,
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError
  }
});

export const getProfitLossReport = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/v2/user-org/reports/pnl",
    data,
    success: (response) => processProfitLossReport(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
})

const processProfitLossReport = (response) => {
  let payloadData = response.response;
  return { type: constants.GET_PROFIT_LOSS_REPORT, payload: payloadData }
}

export const profitLossPdfV2 = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/v2/pnl-report/pdf",
    data,
    success: (response) => processProfitLossPdfV2(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});

const processProfitLossPdfV2 = (response) => {
  let payloadData = response.response;
  return { type: constants.GET_PROFIT_LOSS_PDF_V2, payload: payloadData }
}

export const downloadProfitLossPdfV2 = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/v2/pnl-report/pdf/download",
    data,
    success: (response) => processDownloadProfitLossPdfV2(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});

const processDownloadProfitLossPdfV2 = (response) => {
  let payloadData = response.response;
  return { type: constants.GET_PROFIT_LOSS_PDF_DOWNLOAD_V2, payload: payloadData }
}

export const pnlReportExcel = (month, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/excel/business/pnl?monthYear=" + month,
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});

export const supplierLegerPdfV2 = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/v2/vendor/all/pdf",
    data,
    success: (response) => processSupplierLegerPdfV2(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});

const processSupplierLegerPdfV2 = (response) => {
  let payloadData = response.response;
  return { type: constants.GET_SUPPLIER_LEDGER_PDF_V2, payload: payloadData }
}

export const supplierLegerPdfDownloadV2 = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/v2/vendor/all/pdf/download",
    data,
    success: (response) => processSupplierLegerPdfDownloadV2(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});

const processSupplierLegerPdfDownloadV2 = (response) => {
  let payloadData = response.response;
  return { type: constants.GET_SUPPLIER_LEDGER_PDF_DOWNLOAD_V2, payload: payloadData }
}
export const partyPassbookReport = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/customer/transaction-log/pdf",
    data,
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
export const partyPassbookReportDownload = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/customer/transaction-log/pdf/download",
    data,
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
export const transactionReport = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: `/transaction-history/pdf${data && data.startDateRange && data.startDateRange.endTimeEpoch && data.startDateRange.startTimeEpoch ? `?startDateEpoch=${data.startDateRange.startTimeEpoch}&endDateEpoch=${data.startDateRange.endTimeEpoch}` : ""}${data && data.status && data.status != 'all' ? data.startDateRange && data.startDateRange.endTimeEpoch && data.startDateRange.startTimeEpoch ? `&type=${data.status}` : `?type=${data.status}` : ""}`,
    data,
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
export const transactionReportDownload = (data, onSuccess, onError) => ({
  type: constants.API,
  // data.status && data.status != 'all' ?
  payload: {
    method: "GET",
    url: `/transaction-history/pdf/download${data && data.startDateRange && data.startDateRange.endTimeEpoch && data.startDateRange.startTimeEpoch ? `?startDateEpoch=${data.startDateRange.startTimeEpoch}&endDateEpoch=${data.startDateRange.endTimeEpoch}` : ""}${data && data.status && data.status != 'all' ? data.startDateRange && data.startDateRange.endTimeEpoch && data.startDateRange.startTimeEpoch ? `&type=${data.status}` : `?type=${data.status}` : ""}${data && data.pdfId ? ((data.startDateRange && data.startDateRange.endTimeEpoch && data.startDateRange.startTimeEpoch) || (data.status && data.status != 'all')) ? `&pdfId=${data.pdfId}` : `?pdfId=${data.pdfId}` : ""}`,
    data,
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
export const supplierPassbookReport = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/vendor/transaction-log/pdf",
    data,
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
export const shopListForSelection = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: `/list/shop?pageNo=${data.pageNo}&pageSize=${data.pageSize}${data && data.search ? `&search=${data.search}` : ''}`,
    data,
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
export const supplierPassbookReportDownload = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/vendor/transaction-log/pdf/download",
    data,
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
export const partyLegerPdfV2 = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/v2/customer/all/pdf",
    data,
    success: (response) => processPartyLegerPdfV2(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});

const processPartyLegerPdfV2 = (response) => {
  let payloadData = response.response;
  return { type: constants.GET_PARTY_LEDGER_PDF_V2, payload: payloadData }
}

export const partyLegerPdfDownloadV2 = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/v2/customer/all/pdf/download",
    data,
    success: (response) => processPartyLegerPdfDownloadV2(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});

const processPartyLegerPdfDownloadV2 = (response) => {
  let payloadData = response.response;
  return { type: constants.GET_PARTY_LEDGER_PDF_DOWNLOAD_V2, payload: payloadData }
}

export const partyBalanceExcel = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/excel/party/balance",
    data,
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});

export const supplierBalanceExcel = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/excel/supplier/balance",
    data,
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});

// export const shopListForSelection = (data, onSuccess, onError) => ({
//   type: constants.API,
//   payload: {
//     method: "GET",
//     url: `/list/shop?pageNo=${data.pageNo}&pageSize=${data.pageSize}${data && data.search?`&search=${data.search}`:''}`,
//     data,
//     success: (response) => processUselessData(response),
//     postProcessSuccess: onSuccess,
//     postProcessError: onError,
//   }
// });

export const fetchSupplierTransactionLog = (transactionData, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/vendor/transaction-log",
    data: transactionData,
    success: (response) => processSupplierTransactionLog(response, transactionData && transactionData.merge ? transactionData.merge : false),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
})

const processSupplierTransactionLog = (response, merge) => {
  let payloadData = []

  if (response && response.status && response.status.code == 200) {

    let paymentsResponse = response.response
    
    if (paymentsResponse.transactionLog) {
      for (const key in paymentsResponse.transactionLog) {
        if (Object.hasOwnProperty.call(paymentsResponse.transactionLog, key)) {
          const element = paymentsResponse.transactionLog[key];
          if (element.lineItems) {
            for (const itemKey in element.lineItems) {
              if (Object.hasOwnProperty.call(element.lineItems, itemKey)) {

                const lineItem = element.lineItems[itemKey];
                let transDate = lineItem && lineItem.transactionParams && lineItem.transactionParams[0] ? lineItem.transactionParams[0] : null;
                let vehicleNumber = '';
                lineItem.tripDetails = {
                }
                if (lineItem.tripId) {
                  vehicleNumber = lineItem && lineItem.transactionParams && lineItem.transactionParams[1] ? lineItem.transactionParams[1] : ''
                  let vehicleNumArrayDwebValue = getVehicleNumberValuesDWeb(vehicleNumber);
                  lineItem.tripDetails.vehicleNumArrayDweb = vehicleNumArrayDwebValue;
                  lineItem.tripDetails.vehicle = true;
                  lineItem.vehicleNumber = vehicleNumber
                } else {
                  let trips = lineItem && lineItem.transactionParams && lineItem.transactionParams[1] ? lineItem.transactionParams[1] : '';
                  let transactioNumber = lineItem && lineItem.transactionParams && lineItem.transactionParams[2] ? lineItem.transactionParams[2] : '';
                  //let paymentStatus = lineItem && lineItem.transactionParams && lineItem.transactionParams[3] ? lineItem.transactionParams[3] : '';
                  lineItem.tripDetails.vehicle = false;
                  lineItem.tripDetails.trips = trips;
                  lineItem.tripDetails.transactioNumber = transactioNumber;
                  //lineItem.paymentStatus = paymentStatus;
                }

                let paymentData = {
                  ...lineItem,
                  // date: lineItem && lineItem.createdDate ? moment(lineItem.createdDate).format("DD MMM YY") : transDate,
                  // Using transactionParams date instead of created at date.
                  date: transDate ? transDate : lineItem && lineItem.createdDate ? moment(lineItem.createdDate).format("DD MMM YY") : "--",
                  sorDate: new Date(lineItem && lineItem.createdDate ? lineItem.createdDate : transDate)
                }
                payloadData.push(paymentData);
              }
            }
          }
        }
      }
    }
  }
  return {
    type: constants.SUPPLIER_TRANSACTION_LOG, payload: {
      maxPage: response && response.response && response.response.maxPage ? response.response.maxPage : null,
      transactions: payloadData, merge: merge,
    }
  }
}

export const getVendorPayment = (paymentId, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/vendor/payment/" + paymentId,
    success: (response) => processSupplierPaymentData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

const processSupplierPaymentData = (response) => {
  let payloadData = response.response;
  return { type: constants.GET_SUPPLIER_PAYMENT_DATA, payload: payloadData }
}

export const getSupplierTransactHistory = (paymentId, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/transaction-history/vendor/" + paymentId,
    success: (response) => processSupplierTransactHistory(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

const processSupplierTransactHistory = (response) => {
  let payloadData = response.response;
  return { type: constants.GET_SUPPLIER_TRANSACT_HISTORY, payload: payloadData }
}

export const getTripSuggestionSupplier = (suggestionData, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/vendor/payment/suggestion",
    data: suggestionData,
    success: (response) => processTripSuggestionSupplier(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

const processTripSuggestionSupplier = (response) => {
  let payloadData = response.response;
  return { type: constants.GET_TRIP_SUGGESTION_SUPPLIER, payload: payloadData }
}

export const backButtonStatusUpdate = (data) => {
  return { type: constants.UPDATE_BACK_BUTTON, payload: data }
}

export const onlinePaymentsConfig = (onSuccess, onError, data = { filteredKeys: ["online_payments_config"] }) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/configs/filtered",
    data,
    success: (response) => processOnlinePaymentsConfig(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

const processOnlinePaymentsConfig = (response) => {
  let payloadData = response && response.response && response.response.online_payments_config ? response.response.online_payments_config : {};
  return { type: constants.GET_ONLINE_PAYMENT_CONFIG, payload: payloadData }
}

export const invoiceConfig = (onSuccess, onError, data = { filteredKeys: ["invoice_config"] }) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/configs/filtered",
    data,
    success: (response) => processInvoiceConfig(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
})

const processInvoiceConfig = (response) => {
  let payloadData = response && response.response && response.response.invoice_config ? response.response.invoice_config : {};
  if (payloadData && payloadData.dueDays) {
    payloadData.dueDays.push({ display: 'Custom', unit: 'Custom', quantity: 'Custom' })
  }
  return { type: constants.GET_INVOICE_CONFIG, payload: payloadData }
}

const processUselessData = () => {
  return { type: null, payload: null }
}

export const getSingleShopKhataPdf = (shopId, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: `/khata/shop/${shopId}/pdf/download`,
    success: (response) => processSingleShopKhataPdf(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError
  }
})

const processSingleShopKhataPdf = (response) => {
  let payloadData = response.response;
  return { type: constants.GET_SINGLE_SHOP_KHATA_PDF, payload: payloadData }
}

export const getPreSignedDocument = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: 'GET',
    url: `/sign/document?fileType=${data.fileType}&directory=${data.directory}`,
    success: (response) => { return { type: null, payload: null } },
    postProcessSuccess: onSuccess,
    postProcessError: onError
  }
})

export const searchFuelPumps = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: `/fuel-card/bunks?latitude=${data.lat}&longitude=${data.lng}`,
    data: data,
    success: (response) => { return { type: null, payload: null } },
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
})

export const getSuggestedCities = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: `/places/suggest?name=${data ? data : ""}`,
    data: null,
    doNotDisplaySpinner: true,
    success: (response) => { return { type: null, payload: null } },
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
})
